import React, { useEffect, useState } from 'react';
import { message } from 'antd-v5';
import PageHeaderLayout from '@/component/page-header-layout';
import { Button, Card, Form, InputNumber } from '@/components';
import {
  getDelegationCollectionRuleRequest,
  updateDelegationCollectionRuleRequest,
} from '@/state/request/delegationCollectionRule';
import { createEndValueRule, createIntegerRules, RATIO_MAX, RATIO_MIN } from './formRules';
import './style.less';

const LIST_PATH = '/setting/delegationCollectionRuleSetting';

const DelegationCollectionRuleEdit = ({ history, match }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [record, setRecord] = useState(null);
  const id = match.params.id;

  useEffect(() => {
    const loadRecord = async () => {
      setLoading(true);
      try {
        const res = await getDelegationCollectionRuleRequest();
        if (res?.code !== 200) return;
        const current = (Array.isArray(res.data) ? res.data : []).find(
          (item) => String(item.id) === String(id),
        );
        if (!current) {
          message.error('未找到该催收规则');
          history.replace(LIST_PATH);
          return;
        }
        setRecord(current);
        form.setFieldsValue(current.delegationCollectionRuleItemVO || {});
      } finally {
        setLoading(false);
      }
    };
    loadRecord();
  }, [form, history, id]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (!record) return;
      setSaving(true);
      const res = await updateDelegationCollectionRuleRequest({
        id: record.id,
        delegationCollectionRuleItemCmd: {
          ...values,
          tradeDayEnd: values.tradeDayEnd ?? null,
          creditAmountEnd: values.creditAmountEnd ?? null,
        },
      });
      if (res?.code === 200) {
        message.success('保存成功');
        history.push(LIST_PATH);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageHeaderLayout>
      <Card bordered={false} loading={loading}>
        <Form
          form={form}
          className='delegation-rule-form'
          labelCol={{ flex: '138px' }}
          wrapperCol={{ flex: 1 }}
          requiredMark={false}
          labelAlign='left'
          colon={false}
        >
          <Form.Item
            name='ratio'
            label='佣金比例'
            rules={createIntegerRules('佣金比例', { min: RATIO_MIN, max: RATIO_MAX })}
          >
            <InputNumber min={RATIO_MIN} max={RATIO_MAX} precision={0} addonAfter='%' />
          </Form.Item>

          <Form.Item label='未交易天数' className='delegation-rule-range-row'>
            <Form.Item name='tradeDayStart' rules={createIntegerRules('未交易天数起始值')} noStyle>
              <InputNumber min={0} precision={0} />
            </Form.Item>
            <span className='delegation-rule-separator'>~</span>
            <Form.Item
              name='tradeDayEnd'
              dependencies={['tradeDayStart']}
              rules={[
                ...createIntegerRules('未交易天数结束值', { required: false }),
                createEndValueRule('tradeDayStart', '未交易天数结束值'),
              ]}
              noStyle
            >
              <InputNumber min={0} precision={0} placeholder='不限' />
            </Form.Item>
            <span className='delegation-rule-unit'>天</span>
          </Form.Item>

          <Form.Item label='赊欠金额' className='delegation-rule-range-row'>
            <Form.Item
              name='creditAmountStart'
              rules={createIntegerRules('赊欠金额起始值')}
              noStyle
            >
              <InputNumber min={0} precision={0} />
            </Form.Item>
            <span className='delegation-rule-separator'>~</span>
            <Form.Item
              name='creditAmountEnd'
              dependencies={['creditAmountStart']}
              rules={[
                ...createIntegerRules('赊欠金额结束值', { required: false }),
                createEndValueRule('creditAmountStart', '赊欠金额结束值'),
              ]}
              noStyle
            >
              <InputNumber min={0} precision={0} placeholder='不限' />
            </Form.Item>
            <span className='delegation-rule-unit'>元</span>
          </Form.Item>
        </Form>

        <div className='delegation-rule-footer'>
          <Button type='primary' loading={saving} onClick={handleSave}>
            保存
          </Button>
          <Button onClick={() => history.push(LIST_PATH)}>取消</Button>
        </div>
      </Card>
    </PageHeaderLayout>
  );
};

export default DelegationCollectionRuleEdit;
